// GoZeek webapplication git add -f build/

import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Login from './components/login/Login';
import Dashboard from './components/dashboard/Dashboard';
import PrivateRoute from './components/PrivateRoute';
import { HeaderProvider } from './utils/HeaderContext';

function App() {
  return (
    <Router>
      <div className="App">
        <HeaderProvider> {/* Wrap the whole Router in HeaderProvider */}
          <Routes>
            <Route path="/" element={<Login />} />

            {/* Protected Routes */}
            <Route element={<PrivateRoute />}>
              <Route path="/dashboard" element={<Dashboard />} />
            </Route>
          </Routes>
        </HeaderProvider>
      </div>
    </Router>
  );
}

export default App;
